import { IGroupedComboBoxItem } from 'grouped-combobox-core';

export interface IHasItems {
    items: IGroupedComboBoxItem[];
}

export function findFontIndex(fontKey: string, group: IHasItems): number {
    return group.items.findIndex((item) => item.itemKey === fontKey);
}
